export default class Schedule {
  constructor() {
    this.root = document.querySelector('[data-schedule]');

    if (!this.root) {
      return;
    }

    this.tabs = [...this.root.querySelectorAll('[role="tab"]')];
    this.panels = [...this.root.querySelectorAll('[role="tabpanel"]')];

    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    this.root.addEventListener('click', this.onClick);
    this.root.addEventListener('keydown', this.onKeydown);
  }

  select(index) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;

      tab.setAttribute('aria-selected', active);
      tab.tabIndex = active ? 0 : -1;
      this.panels[i].hidden = !active;
    });
  }

  onClick(e) {
    const tab = e.target.closest('[role="tab"]');

    if (tab) {
      this.select(this.tabs.indexOf(tab));
      return;
    }

    const trigger = e.target.closest('.event__trigger');

    if (trigger) {
      const open = trigger.getAttribute('aria-expanded') === 'true';

      trigger.setAttribute('aria-expanded', !open);
      return;
    }

    const button = e.target.closest('[data-atcb]');

    if (button) {
      import('add-to-calendar-button').then(({ atcb_action }) => {
        atcb_action({ ...JSON.parse(button.dataset.atcb), trigger: 'click' }, button);
      });
    }
  }

  onKeydown(e) {
    const current = this.tabs.indexOf(e.target);

    if (current < 0 || !['ArrowLeft', 'ArrowRight'].includes(e.key)) {
      return;
    }

    const step = e.key === 'ArrowRight' ? 1 : -1;
    const next = (current + step + this.tabs.length) % this.tabs.length;

    this.select(next);
    this.tabs[next].focus();
  }

  destroy() {
    if (!this.root) {
      return;
    }

    this.root.removeEventListener('click', this.onClick);
    this.root.removeEventListener('keydown', this.onKeydown);
  }
}
